import { IObservableValue, observable } from "mobx";

const observables: { [name: string]: IObservableValue<any> } = {};

export function localSettingObservable(name: string) {
    return (target: any, key: string, descriptor?: PropertyDescriptor) => {
        const saved = localStorage.getItem(name);
        observables[name] =
            observables[name] ||
            observable.box(
                (saved && saved !== "undefined" && JSON.parse(saved)) ||
                    undefined,
            );
        const box = observables[name];
        const initialized = Symbol("initialized");
        Object.defineProperty(target, key, {
            ...descriptor,
            configurable: true,
            get() {
                return box.get();
            },
            set(value: any) {
                if (!this[initialized] && saved !== null) {
                    this[initialized] = true;
                    return;
                }
                if (value !== undefined) {
                    localStorage.setItem(name, JSON.stringify(value));
                } else {
                    localStorage.removeItem(name);
                }
                box.set(value);
            },
        });
    };
}
